(function () {
  try { init_index_carousel(); } catch(e) {console.log(e); }
  try { init_button(); } catch(e) {console.log(e); }
})();
  
function init_index_carousel() {
  var cus_carousel = $('#cus_carousel').owlCarousel({
    autoplay:true,
    autoplayTimeout: 5000,
    margin:0,
    loop:true,
    autoWidth: true,
    nav:false,
    items:1,
    center: true,
    responsive : {
      // breakpoint from 0 up
      768 : {
        autoWidth: true,
      }
    }
  });
}

function init_product_carousel() {
  $('#csr_carousel').owlCarousel({
    autoplay: true,
    autoplayTimeout: 5000,
    margin: 20,
    loop: true,
    autoWidth: false,
    nav: true,
    items: 2,
    center: false,
    dots: false,
    navText: ["<i class='fas fa-angle-left fa-fw'></i>","<i class='fas fa-angle-right fa-fw'></i>"],
    responsive : {
      // breakpoint from 0 up
      768 : {
        margin: 40,
      },
      // breakpoint from 480 up
      992 : {
        items: 4,
        margin: 70,
      }
    }

  });
}

class BookRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('book-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.ccl_item')) {
            this.classList.add('cus_book_recommendations--loaded');
          }

          init_product_carousel();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('book-recommendations', BookRecommendations);

function init_button() {
  $('#goToTop').click(function() {
      $('html, body').animate({
          scrollTop: $('body').offset().top
      }, 600)
  });
  $('#cc_btn_confirm').click(function() {
    const objs = $('#ContactForm input[need],#ContactForm select[need],#ContactForm textarea[need]');
    if(objs.length > 0) {
      for (var i = objs.length - 1; i >= 0; i--) {
        const obj = objs[i]
        if($(obj).val() == "" || $(obj).val() == null) {
          alert("必須項目を入力してください。")
          return
        }
      }
    }
    $('.cscf_item  input,.cscf_item select,.cscf_item textarea, .csc_privacy input').prop('disabled', true);
    $(this).fadeOut('fast', () => { 
      $('#cc_btn_back,#cc_btn_submit').fadeIn(); 
      $('.csc_privacy').fadeOut(); 
    });
    $('html, body').animate({
        scrollTop: $('body').offset().top
    }, 600)
  })
  $('#cc_btn_back').click(() => {
    $('.cscf_item input,.cscf_item select,.cscf_item textarea,.csc_privacy, .csc_privacy input').prop('disabled', false);
    $('#cc_btn_back,#cc_btn_submit').fadeOut('fast', () => { 
      $('#cc_btn_confirm').fadeIn();
      $('.csc_privacy').fadeIn(); 
    });
  })
  $('#cc_btn_submit').click(() => {
    $('.cscf_item input,.cscf_item select,.cscf_item textarea,.csc_privacy, .csc_privacy input').prop('disabled', false);
    $('#ContactForm').submit();
    $('.csc_privacy').fadeIn(); 
  });
  const init_scroll = () => {
      if($(window).scrollTop() > 200) {
        if($(window).width() > 767) { 
          $('#goToTop').fadeIn().css('display', 'flex');
        }
        $('.cus_header__top').addClass('scroll');
      } else {
        if($(window).width() > 767) { 
          $('#goToTop').fadeOut();
        }
        $('.cus_header__top').removeClass('scroll');
      }
  }
  $(window).scroll(() => {
    init_scroll();
  })
  init_scroll();
  
//   $('#csc_btn_confirm').click(function() {
//     const objs= $('#csc_form input, #csc_form select,, #csc_form textarea');
//     for (var i = objs.length - 1; i >= 0; i--) {
//       const obj = objs[i];
//       if($obj.val() == "") {
        
//       }
//     }
//     $('#csc_form input, #csc_form select,, #csc_form textarea').prop('disabled', true);
//     $('#cc_btn_confirm, #cc_btn_back').fadeIn().css('display', 'flex');
//     $(this).fadeOut();
//   })
//   $('#cc_btn_back').click(function() {
//     $('#csc_form input, #csc_form select,, #csc_form textarea').prop('disabled', false);
//     $('#cc_btn_confirm, #cc_btn_back').fadeOut();
//     $(this).fadeIn().css('display', 'flex');
//   })
}